import React from 'react';
import { getBiLogger } from '../../../utils/biLogger';
import { isInModal } from '../../../utils/isInModal';
import { wixSdkAdapter } from '../../../utils/wixSdkAdapter';
import { BoletoModalType, BoletoProps } from './Boleto/types';
import { convertToBiLoggerParams } from './Boleto/utils/biUtils';
import { BoletoModalView } from './view';
import { isFullWidthWindow } from './utils';
import { DeviceType } from '../../../types/DeviceType';

export interface BoletoModalControllerProps extends BoletoProps {
  deviceType?: DeviceType;
}

export interface BoletoModalControllerState {
  isLoading: boolean;
}

export class BoletoModalController extends React.Component<
  BoletoModalControllerProps,
  BoletoModalControllerState
> {
  private isComponentMounted: boolean = false;
  Boleto: React.FC<BoletoProps>;
  state = { isLoading: true };

  constructor(props: BoletoModalControllerProps) {
    super(props);
    this.loadBoletoView();
  }

  componentDidMount() {
    this.isComponentMounted = true;

    // if modal is rendered in an iframe in "cover" mode (bookings) and is not being in viewport - we need to scroll iframe up
    if (this.modalType === BoletoModalType.Cover) {
      if (wixSdkAdapter.isConnected()) {
        wixSdkAdapter.Wix.scrollTo(0, 0);
      } else {
        document.body.scrollIntoView(true);
      }
    }
  }

  componentWillUnmount() {
    this.isComponentMounted = false;
  }

  private async loadBoletoView() {
    const module = await import(/* webpackChunkName: "boleto" */ './Boleto');
    this.Boleto = module.Boleto;
    this.safeSetState({ isLoading: false });
  }

  get modalType() {
    if (this.props.modalType) {
      return this.props.modalType;
    }

    if (isInModal()) {
      return BoletoModalType.Overlayed;
    }

    // if rendered in an iframe which is not 100% wide
    if (!isFullWidthWindow()) {
      return BoletoModalType.Cover;
    }

    return BoletoModalType.Standard;
  }

  safeSetState = (state, cb?) => {
    if (this.isComponentMounted) {
      this.setState(state, cb);
    } else if (cb) {
      cb();
    }
  };

  handleClose = (viaCloseButton: boolean = false) => {
    getBiLogger().boletoPopUpClosed({
      ...convertToBiLoggerParams(this.props.boleto),
      close_button: viaCloseButton,
    });
    this.props.onClose();
  };

  render() {
    const { boleto } = this.props;
    return (
      <BoletoModalView
        isLoading={this.state.isLoading}
        component={this.Boleto}
        modalType={this.modalType}
        boleto={boleto}
        onClose={this.handleClose}
      />
    );
  }
}
